import { render, staticRenderFns } from "./SpOrderCreateEdit.vue?vue&type=template&id=4bf7eb10&scoped=true"
import script from "./SpOrderCreateEdit.vue?vue&type=script&lang=js"
export * from "./SpOrderCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./SpOrderCreateEdit.vue?vue&type=style&index=0&id=4bf7eb10&prod&scoped=true&lang=css"
import style1 from "./SpOrderCreateEdit.vue?vue&type=style&index=1&id=4bf7eb10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf7eb10",
  null
  
)

export default component.exports